import { useState } from "react";
import { getDateFromYmd, useBookingPageContext } from "context/bookingContext/BookingPageContainer";
import { getFirstAndLastDay, toYmd } from "utils/string-localization-helper";
import DateInput from "components/DateInput";

export function CalendarContainer({
    dates = []
}: {
    dates?: string[]
}) {
    const { activeDate, setActiveDate, router } = useBookingPageContext()
    const [first_day, last_day] = getFirstAndLastDay(activeDate)
    const highlighted: number[] = []
    const [calendar_date, setCalendarDate] = useState(activeDate)

    if (dates) {
        for (var i = 0; i < dates.length; i++) {
            const dd = getDateFromYmd(dates[i])
            if (dd >= first_day && dd <= last_day) {
                highlighted.push(dd.getDate())
            }
        }
    }

    function updateDate(date: Date) {
        setCalendarDate(date)
        setActiveDate(date)
        router.push({
            query: {
                ...router.query,
                d: toYmd(date),
            },
        })
    }

    return (
        <div className="">
            <DateInput
                calendarClassName="flex-none rounded-lg custom-date-picker"
                minDate={new Date()}
                onChange={updateDate}
                onMonthChange={updateDate}
                dateFormat="dd/MM/yy"
                selected={calendar_date}
                highlightDates={dates.map(d => new Date(d))}
                inline
            />
        </div>
    )
}

export default CalendarContainer